// extracted by mini-css-extract-plugin
module.exports = {"top":"Home_top__H_4Ow","main":"Home_main__zgAJj","container":"Home_container__CCFUG"};